export default __webpack_public_path__ + "static/mongodb-bdcaeb2d267ec943d838e608e3723d0c.png";